module.exports = __webpack_public_path__ + "img/cylinder.f86ba337.svg";